import { useState, useRef } from "react";
import { FaChevronRight } from "react-icons/fa";

export default function NavButtons() {
  const [active, setActive] = useState("who");
  const scrollRef = useRef(null);

  const handleClick = (id) => {
    setActive(id);
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: scrollRef.current.offsetWidth,
        behavior: "smooth",
      });
    }
  };

  const buttons = [
    { id: "who", label: "WHO WE ARE" },
    { id: "team", label: "MEET THE TEAM" },
    { id: "partners", label: "OUR PARTNERS" },
    { id: "careers", label: "CAREERS" },
  ];

  return (
    <div className="sticky top-0 md:top-0 left-0 w-full z-50 bg-[#F5F5F5] shadow-md">
      {/* Mobile View (Slider with Right Icon) */}
      <div className="relative md:hidden flex items-center">
        <div
          ref={scrollRef}
          className="flex overflow-x-auto no-scrollbar snap-x snap-mandatory w-full"
        >
          {buttons.map((btn) => (
            <button
              key={btn.id}
              onClick={() => handleClick(btn.id)}
              className={`snap-center flex-shrink-0 w-full text-center py-3 text-base font-serif relative text-[#000]
                after:content-[''] after:absolute after:left-0 after:bottom-0 
                after:w-full after:h-[2px] after:transition-all after:duration-300
                ${
                  active === btn.id
                    ? "after:bg-[#755542]"
                    : "after:bg-transparent hover:after:bg-[#755542]"
                }`}
            >
              {btn.label}
            </button>
          ))}
        </div>

        {/* Right Scroll Icon */}
        <button onClick={scrollRight} className="absolute right-2 p-1">
          <FaChevronRight className="w-4 h-4 text-gray-700" />
        </button>
      </div>

      {/* Desktop View (Normal Inline Nav) */}
      <div className="hidden md:flex gap-8 items-center justify-center text-center px-6 md:px-12 py-3.5 font-[sans-serif]">
        {buttons.map((btn) => (
          <button
            key={btn.id}
            onClick={() => handleClick(btn.id)}
            className={`relative text-sm md:text-lg font-serif text-[#000] pb-1
              after:content-[''] after:absolute after:left-0 after:bottom-0 
              after:w-full after:h-[2px] after:transition-all after:duration-300
              ${
                active === btn.id
                  ? "after:bg-[#755542]"
                  : "after:bg-transparent hover:after:bg-[#755542]"
              }`}
          >
            {btn.label}
          </button>
        ))}
      </div>
    </div>
  );
}
